import React from "react";

function AutomatedSystem() {
  return (
    <>
      <div className="services-style-five-area default-padding bottom-less">
        <div className="container">
          <div className="left-heading">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <h4 className="sub-title">Service Blocks</h4>
                <div className="right">
                  <h2 className="title split-lines">
                    Key Features of Our MLM Platforms
                  </h2>
                  <p>
                    Explore the powerful features of our MLM platforms, designed
                    to streamline operations, enhance user engagement, and drive
                    sustainable growth across all levels of your network.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="services-style-five-items">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <i className="fas fa-swatchbook" />
                  <h4>Multi-Tier Commission Tracking</h4>
                  <p>
                    Efficiently manage and track multi-level commissions,
                    allowing accurate and transparent earnings distribution at
                    every level.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <i className="fas fa-theater-masks" />
                  <h4>Automated Payout System</h4>
                  <p>
                    With built-in automated payouts, users receive their
                    commissions and bonuses directly to their wallets or bank
                    accounts on schedule, reducing administrative effort.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <i className="fas fa-window" />
                  <h4>Referral & Reward Management</h4>
                  <p>
                    Fully customizable referral and reward systems to
                    incentivize users, increase retention, and encourage network
                    expansion.
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <i className="fas fa-swatchbook" />
                  <h4>Real-Time Dashboard & Analytics</h4>
                  <p>
                    Gain insights into your network performance with a
                    comprehensive dashboard, providing real-time data on user
                    activity, earnings, and growth.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <i className="fas fa-theater-masks" />
                  <h4>Integrated Wallet & Payment Gateways</h4>
                  <p>
                    Enable seamless transactions with integrated wallets and
                    support for multiple payment gateways, including crypto and
                    fiat currency options.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <i className="fas fa-window" />
                  <h4>KYC/AML Compliance</h4>
                  <p>
                    Keep your platform compliant with built-in KYC (Know Your
                    Customer) and AML (Anti-Money Laundering) protocols to
                    enhance trust and security.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AutomatedSystem;
